import { Link } from "office-ui-fabric-react"

const ResourcePlanningSettingsTooltip = () => {
    return <div>
        Define the level on which Resource Planning will be performed.
        Please note that Resource Planning will be available only on the selected level and will be disabled on other levels.
        <br />
        Please refer to the <Link href="https://help.ppm.express/89495-ppm-express-settings/522610" target="_blank">article</Link> for more details.
    </div>
}

export default ResourcePlanningSettingsTooltip;